module.exports = __webpack_public_path__ + "img/inetlogo.0b3c61f1.png";